export default __webpack_public_path__ + "static/media/hkgrotesk-bold-webfont.a163db8d.ttf";